import React, { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { toast } from "sonner";
import api from "@/lib/api";
import { CheckInBoard } from "@/components/CheckInBoard";
import { prettyDate } from "@/components/LeadPractice";
import { Button } from "@/components/ui/button";

export default function CrewCheckIn() {
  const { token } = useParams();
  const key = `crew_session_${token}`;
  const [session, setSession] = useState(() => sessionStorage.getItem(key) || "");
  const [code, setCode] = useState("");
  const [data, setData] = useState(null);
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(null);
  const load = useCallback(() => {
    if (!session) return Promise.resolve();
    return api.post(`/checkin/crew/${token}/roster`, { session }).then((r) => { setData(r.data); setErr(""); })
      .catch((e) => { const s = e.response?.status; if (s === 401) { sessionStorage.removeItem(key); setSession(""); } if (s === 401 || s === 403 || s === 404) { setData(null); } setErr(e.response?.data?.detail || "Could not load"); });
  }, [session, token, key]);
  useEffect(() => { load(); if (!session) { return undefined; } const t = setInterval(load, 8000); return () => clearInterval(t); }, [load, session]);
  const enter = async (e) => {
    e.preventDefault();
    try { const r = await api.post(`/checkin/crew/${token}/session`, { code }); sessionStorage.setItem(key, r.data.session); setSession(r.data.session); setErr(""); }
    catch (e2) { setErr(e2.response?.data?.detail || "Could not sign in"); }
  };
  const toggle = async (r) => {
    setBusy(r.dancer_id);
    try { await api.post(`/checkin/crew/${token}/mark`, { session, dancer_id: r.dancer_id, present: !r.checked_in }); await load(); }
    catch (e) { toast.error(e.response?.data?.detail || "Error"); } finally { setBusy(null); }
  };
  return (
    <div className="min-h-screen bg-[#f7f7f5] px-4 py-6" data-testid="crew-page">
      <div className="max-w-xl mx-auto">
        <div className="flex items-center gap-3 mb-5"><img src="/logo.png" alt="Studio V" className="w-10 h-10 rounded-xl" /><div><p className="font-head font-bold text-lg leading-tight">Backstage check-in</p><p className="text-xs text-muted-foreground">Studio V volunteer crew</p></div></div>
        {!session ? (
          <form onSubmit={enter} className="bg-white rounded-3xl border p-6 space-y-4" data-testid="crew-code-form">
            <p className="font-semibold">Enter the 4-digit code from the director</p>
            <input data-testid="crew-code-input" inputMode="numeric" autoComplete="one-time-code" maxLength={4} value={code} onChange={(e) => setCode(e.target.value.replace(/\D/g, ""))}
              className="w-full h-16 text-center text-3xl tracking-[0.6em] font-mono rounded-2xl border-2 focus:border-teal outline-none" placeholder="••••" />
            {err && <p className="text-sm text-red-600" data-testid="crew-error">{err}</p>}
            <Button type="submit" data-testid="crew-code-submit" disabled={code.length !== 4} className="w-full h-12 rounded-full bg-teal hover:bg-teal-dark text-base">Start check-in</Button>
          </form>
        ) : err && !data ? <p className="text-red-600" data-testid="crew-error">{err}</p> : !data ? <p className="text-muted-foreground">Loading…</p> : <>
          <p className="text-sm text-muted-foreground mb-3">{data.production_name} · {prettyDate(data.date)} · tap a name when the dancer arrives</p>
          <CheckInBoard data={data} onToggle={toggle} busyId={busy} />
        </>}
      </div>
    </div>
  );
}
